module.exports = __webpack_public_path__ + "img/6153909153365b4da9530e25ece7f683.svg";